import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { HowItWorks } from "./components/HowItWorks";
import { QuoteForm } from "./components/QuoteForm";
import { Coverage } from "./components/Coverage";
import { Testimonials } from "./components/Testimonials";
import { FAQ } from "./components/FAQ";
import { Footer } from "./components/Footer";
import { AdminDashboard } from "./components/AdminDashboard";
import { FloatingContactButtons } from "./components/FloatingContactButtons";
import { Blog } from "./components/Blog";
import { BlogPost } from "./components/BlogPost";
import { SEOHead } from "./components/SEOHead";
import { Toaster } from "sonner";

// SEO Service Pages
import { BreakdownRecoveryPage } from "./components/services/BreakdownRecoveryPage";
import { VehicleTransportPage } from "./components/services/VehicleTransportPage";
import { AuctionTransportPage } from "./components/services/AuctionTransportPage";
import { JumpStartPage } from "./components/services/JumpStartPage";
import { EmergencyRecoveryPage } from "./components/services/EmergencyRecoveryPage";
import { VehicleDisposalPage } from "./components/services/VehicleDisposalPage";
import { PartsSalesPage } from "./components/services/PartsSalesPage";
import { MobileMechanicPage } from "./components/services/MobileMechanicPage";
import { VehicleServicingPage } from "./components/services/VehicleServicingPage";

// SEO Location Pages
import { HackneyPage } from "./components/locations/HackneyPage";
import { ShoreditchPage } from "./components/locations/ShoreditchPage";
import { StratfordPage } from "./components/locations/StratfordPage";
import { IslingtonPage } from "./components/locations/IslingtonPage";
import { TowerHamletsPage } from "./components/locations/TowerHamletsPage";
import { BethnalGreenPage } from "./components/locations/BethnalGreenPage";

// 404 Page
import { NotFoundPage } from "./components/NotFoundPage";

const Home = () => {
  return (
    <div className="min-h-screen">
      <SEOHead />
      <Header />
      <Hero />
      <Services />
      <HowItWorks />
      <QuoteForm />
      <Coverage />
      <Testimonials />
      <FAQ />
      <Footer />
      <FloatingContactButtons />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          
          {/* SEO Service Pages */}
          <Route path="/services/breakdown-recovery" element={<BreakdownRecoveryPage />} />
          <Route path="/services/vehicle-transport" element={<VehicleTransportPage />} />
          <Route path="/services/auction-transport" element={<AuctionTransportPage />} />
          <Route path="/services/jump-start" element={<JumpStartPage />} />
          <Route path="/services/emergency-recovery" element={<EmergencyRecoveryPage />} />
          <Route path="/services/vehicle-disposal" element={<VehicleDisposalPage />} />
          <Route path="/services/parts-sales" element={<PartsSalesPage />} />
          <Route path="/services/mobile-mechanic" element={<MobileMechanicPage />} />
          <Route path="/services/vehicle-servicing" element={<VehicleServicingPage />} />
          
          {/* SEO Location Pages */}
          <Route path="/locations/hackney" element={<HackneyPage />} />
          <Route path="/locations/shoreditch" element={<ShoreditchPage />} />
          <Route path="/locations/stratford" element={<StratfordPage />} />
          <Route path="/locations/islington" element={<IslingtonPage />} />
          <Route path="/locations/tower-hamlets" element={<TowerHamletsPage />} />
          <Route path="/locations/bethnal-green" element={<BethnalGreenPage />} />
          
          {/* 404 Catch-all Route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
